module.exports = __webpack_public_path__ + "media/images/icons/anonymity-d0cc068716e23d9e475e161f3b329076.png";